import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { RoundedFriendsItem } from '@/components/RoundedFriendsItem'
import { LoadingSpinner } from '@/components/LoadingSpinner'
import { useFavoriteUsers } from '@/hooks/useContacts'
import type { UsersAndContacts } from '@/types/contacts'
import { SettingItem } from '@/components/SettingItem'
import { Plus } from '@/assets'

interface FavoritesListProps {
  onContactSelected: (contact: UsersAndContacts) => void
  className?: string
  isMultiSelectMode?: boolean
  isContactSelected?: (contactId: string) => boolean
  favorites?: UsersAndContacts[]
  isLoading?: boolean
}

export const FavoritesList = forwardRef<HTMLInputElement, FavoritesListProps>(
  function FavoritesList(
    {
      onContactSelected,
      favorites = [],
      isLoading,
      className = '',
      isMultiSelectMode = false,
      isContactSelected,
    },
    ref,
  ) {
    const { t } = useTranslation()

    if (isLoading) {
      return (
        <BaseView className={`p-4 ${className}`}>
          <BaseText className="text-lg font-semibold text-gray-900 mb-4">
            {t('common:pinned')}
          </BaseText>
          <BaseView className="flex-row items-center justify-center py-8">
            <LoadingSpinner size="small" />
          </BaseView>
        </BaseView>
      )
    }

    if (!favorites || favorites.length === 0) {
      return (
        <BaseView className={`${className}`} style={{ gap: '16px' }}>
          {/* Pinned Header - точно как в RN версии */}
          {/* <BaseView className="">
          <BaseText
            fontSize={18}
            fontFamily="semibold"
            color="label.description"
            className="text-center"
          >
            No pinned contacts. Search for your friends that are already on Kem
            and pin them!
          </BaseText>
        </BaseView> */}
          {/* TODO: TRANSLATE */}
          <SettingItem
            icon={Plus}
            circleSize={56}
            iconSize={17}
            iconBgColor="linear-gradient(41deg,#66FFED 3.6%,#325FFF 83.9%)"
            title="Stay Close"
            description="Pin friends and contacts for quick
and easy connection!"
            onPress={() => {
              // Use setTimeout to ensure focus happens after click event completes
              // This prevents the click target from stealing focus back
              setTimeout(() => {
                if (ref && typeof ref !== 'function') {
                  ref.current?.focus()
                }
              }, 0)
            }}
          />
        </BaseView>
      )
    }

    return (
      <BaseView className={`${className}`} style={{ gap: '16px' }}>
        {/* Pinned Header - точно как в RN версии */}
        <BaseView className="">
          <BaseText
            fontSize={18}
            fontFamily="semibold"
            color="label.textTextInput"
            style={{
              margin: 0,
            }}
          >
            {t('common:pinned')}
          </BaseText>
        </BaseView>

        {/* Horizontal Scrollable Pinned Contacts - точно как в RN версии */}
        <BaseView
          className="hide-scrollbar"
          style={{
            overflowX: 'auto',
            overflowY: 'hidden',
            // Скрываем скроллбар
            scrollbarWidth: 'none', // Firefox
            msOverflowStyle: 'none', // IE и Edge
          }}
        >
          <BaseView
            style={{
              gap: '8px', // SpaceBetween x={9} из RN версии
              minWidth: 'fit-content',
              flexDirection: 'row',
            }}
          >
            {favorites.map((contact, index) => (
              <RoundedFriendsItem
                key={`favorite-${contact.id}-${index}`}
                contact={contact}
                onPress={onContactSelected}
                isMultiSelectMode={isMultiSelectMode}
                isSelected={
                  isMultiSelectMode && isContactSelected
                    ? isContactSelected(contact.id)
                    : false
                }
              />
            ))}
          </BaseView>
        </BaseView>
      </BaseView>
    )
  },
)

export default FavoritesList
